import React from 'react'

/**
 * Converts URLs in text to clickable links with security attributes
 * @param text - The text containing potential URLs
 * @returns JSX elements with clickable links
 */
export const linkifyText = (text: string): React.ReactNode[] => {
    // URL regex pattern that matches http/https URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g

    const parts = text.split(urlRegex)
    const result: React.ReactNode[] = []

    parts.forEach((part, index) => {
        if (urlRegex.test(part)) {
            // This is a URL - make it clickable
            result.push(
                <a
                    key={index}
                    href={part}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: 'var(--mantine-color-blue-6)',
                        textDecoration: 'underline',
                        wordBreak: 'break-all'
                    }}
                    onClick={(e) => {
                        // Prevent the click from bubbling up to parent elements
                        e.stopPropagation()
                    }}
                >
                    {part}
                </a>
            )
        } else {
            // This is regular text - preserve whitespace
            result.push(
                <span key={index} style={{ whiteSpace: 'pre-wrap' }}>
                    {part}
                </span>
            )
        }
    })

    return result
} 